export default __webpack_public_path__ + "static/media/palm.e9533f9a.jpg";